/* istanbul ignore file */
export default {
  name: {
    type: 'string',
    required: true,
  },
};
